export default __webpack_public_path__ + "static/media/celebrate.31bc7f9db6ee9a68bd5424371acee45b.svg";